import { useState } from 'react';

export const useImageModal = () => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openImageModal = (index) => {
    setCurrentImageIndex(index);
    setShowImageModal(true);
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setCurrentImageIndex(0);
    document.body.style.overflow = 'unset'; // Restore scrolling
  };

  return {
    showImageModal,
    currentImageIndex,
    setCurrentImageIndex,
    openImageModal,
    closeImageModal
  };
};